<div class="form-group">
    <div>
        <button type="button" [disabled]="disabled" class="close" (click)="removeStreet()"
             data-dismiss="modal" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
		<div class="form-group">
			<div class="ft-address-autocomplete ">
                <input #elAutoComplete class="form-control" [id]="fieldName+'autocomplete'" 
                placeholder="Search" type="text" [readonly]="disabled">
			</div>
		</div>
	</div>
</div>

<div [ngClass]="disabled ? 'disable-element' : ''">
    <div class="col-xs-12" style="height: 100%;  overflow: hidden;">
        <div #targetMap [id]="fieldName+'_map'" class="map">
        </div >
    </div>


<table #elTable [id]="'table'+fieldName" class="display" width="100%"></table>
<!-- TO DO : <ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display> -->
</div>
